<template>
<div class="z-main">
 	<header class="z-header">
		<div><router-link to="/my"><img src="../../assets/sysbars/left.png" /></router-link></div>
		<div>{{$t('修改登录密码')}}</div>
		<div></div>
	</header>
	<div class="z-body">
	<section>
	  <div class="inputBox">
		<div style="width: 10%;">
		  <img class="z-icon" src="../../assets/icon/register/password2.png">
		</div>
		<div style="width: 90%;">
		  <input type="password" v-model="oldPassWord" style="outline:none;font-size: 16px;width:100%;" :placeholder="$t('原登录密码')">
		</div>
		<!-- <div style="width: 30%;text-align: right"></div> -->
	  </div>
	</section>
	<section>
	  <div class="inputBox">
		<div style="width: 10%;">
		  <img class="z-icon" src="../../assets/icon/register/password2.png">
		</div>
		<div style="width: 90%;">
		  <input type="password" v-model="newPassWord1" style="outline:none;font-size: 16px;width:100%;" :placeholder="$t('设置新登录密码')">
		</div>
		<!-- <div style="width: 30%;text-align: right"></div> -->
	  </div>
	</section>
	<section>
	  <div class="inputBox">
		<div style="width: 10%;">
		  <img class="z-icon" src="../../assets/icon/register/password2.png">
		</div>
		<div style="width: 90%;">
		  <input type="password" v-model="newPassWord2" style="outline:none;font-size: 16px;width:100%;" :placeholder="$t('确认新登录密码')">
		</div>
		<!-- <div style="width: 30%;text-align: right"></div> -->
	  </div>
	</section>
	<section style="text-align: center">
			<div @click="changePassWord"  class="common-btn">{{$t('提交')}}</div>
		</section>
  </div>
</div>
</template>

<script>
	export default {
		name: 'changePassWord',
		data() {
			return {
			  oldPassWord:"",
			  newPassWord1:"",
			  newPassWord2:"",
			}
		},
		mounted() {
		},
		methods: {
		  changePassWord:function () {
			let _this=this
			if(this.oldPassWord=="" ||this.newPassWord1=="" ||this.newPassWord2==""){
			  this.$store.commit('layer',this.$t('部分信息未填写'))
			}else if(this.newPassWord1 != this.newPassWord2){
			  this.$store.commit('layer',this.$t('两组密码不相同'))
			}else{
			  this.post('api/Users/SetPwd.html', {
				newpwd: this.newPassWord2,
				oldpwd:this.oldPassWord
			  }).then((res) => {
				this.$store.commit('layer',res.msg)
				if(res.code==0){
				  this.removeToken()
				  this.jump('/user/login')
				}
			  })
			}
		  }
		}
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.hearIcon{
	width: 20px;
	height: 20px;
}
  .inputBox{
	background-color: #424355;
	color: #fff;
	display: flex;
	justify-content: space-between;
	align-items: center;
	height: 60px;
	padding:0 30px 0 30px;
	margin-bottom:1px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/my/changePassWord.vue